module.exports = "<div class=\"container\">\n  <h1> Token Inválido :( </h1>\n</div>"